import { render, staticRenderFns } from "./sidebar1.vue?vue&type=template&id=5db6e2c2&scoped=true&"
import script from "./sidebar1.vue?vue&type=script&lang=js&"
export * from "./sidebar1.vue?vue&type=script&lang=js&"
import style0 from "./sidebar1.vue?vue&type=style&index=0&id=5db6e2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db6e2c2",
  null
  
)

export default component.exports